var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { mortgageData, templates } = options; 
__p+='\n<div class="panel-body">\n  ';
 if (mortgageData) { 
__p+='\n    '+
((__t=( templates.graph({mortgageData, templates}) ))==null?'':__t)+
'\n    '+
((__t=( templates.calculator({mortgageData, templates}) ))==null?'':__t)+
'\n  ';
 } 
__p+='\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/panel-body.jst.ejs